import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../../../../baseClasses/BaseComponent';

import OfflineCloudIcon from '../../../../../assets/images/offline-cloud.svg';
import animator from '../../../../../helpers/animator';
import dataModel from '../../../../../models/DataModel';
import DataSource from '../../../../../dao/DataSource/DataSource';
import './NewTask.scss';

class NewTask extends BaseComponent {

  constructor(props) {
    super(props);
    this.animator = new animator();
    this.state = {
    };
  }

  handleTaskUpdate(task, action, acData, fetchedData) {
    this.setState({ task });
  }

  componentDidMount() {
    if (this.props.task) {
      this.taskDataSource = new DataSource('Task', this.props.task.id, { task: { build: {} } }, this.handleTaskUpdate);
      this.taskDataSource.get();
    }

    if (this.props.project) {
      this.setState({ project: this.props.project });
    }
  }

  componentWillUnmount() {
    if (this.taskDataSource) {
      this.taskDataSource.release();
      this.taskDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
  }

  handleNavigateToTask(){
    this.props.history.push(`/mobile/projects-tasks/task/${this.props.task.id}`);
  }

  convertTaskStatus(status){
    return status.split('_').map(word => word.substr(0,1).toUpperCase() + word.substr(1).toLowerCase()).join(' ');
  }

  render() {
    const { task, project } = this.state;
    
    if (!task || !project){
      return null;
    }

    const hasRejected = task.completion_criteria_counts ? (task.completion_criteria_counts.rejected > 0) : false;

    let offlineChangesIndicator;
    let attachmentCount = task.task_attachments_count;

    let statusText = this.convertTaskStatus(task.status);

    if (task._dirty) {
      offlineChangesIndicator = <img className="offline-indicator" src={OfflineCloudIcon} alt="changes pending"></img>;
    }

    return (
      <div className="task"  onClick={this.handleNavigateToTask}>
        {
          hasRejected &&
          <div className="rejected-indicator"/>
        }
        <div className="task-info" >
          <div className="task-identity" >
            <div className="task-name">{task.name.toUpperCase()}</div>
            <div className="project-name">{project.name}</div>
            <div className="project-name">{task.build ? task.build.name : 'No Build'}</div>
          </div>
          <div className="img-container">
            {offlineChangesIndicator}
            <div className="right-arrow" />
          </div>
        </div>
        <div className="bottom-row">
          <div className="info-icon-row">
            <div className="attachments">
              <div className="attachment-icon" />
              <div className="icon-text">{attachmentCount}</div>
            </div>
            <div className="completion-criteria">
              <div className="completion-icon" />
              <div className="icon-text">{task.completion_criteria_counts.completed + '/' + task.completion_criteria_counts.total}
              </div>
            </div>
          </div>
          <div className="right-side">
            <div className={'task-status ' + (task.status ? task.status : '')}>{statusText}</div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    inProgress: state.main.inProgress,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = (dispatch) => {
  return {
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NewTask));



// WEBPACK FOOTER //
// ./src/containers/TasksContainer/NewProjectsTasksContainer/ProjectTasks/NewTask/index.js